export { ThemeSwitcher } from './src/ThemeSwitcher';
export const themeStyles = {
  'dark-mode-theme': 'dark-mode-theme',
};
